import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Programs } from '../../../models/programs/programs';
import { UrlConstants } from '../../../constants/url.constants';

@Injectable({
  providedIn: 'root'
})
export class ProgramsService {
  readonly http = inject(HttpClient);

  getPrograms(): Observable<Programs[]>{
    return this.http.get<Programs[]>(UrlConstants.PROGRAMS_URL);
  }
}
